import axios from 'axios';
import RestService from '../../helpers/RestService';
import moment from 'moment';
import {toastr} from 'react-redux-toastr'

axios.defaults.headers.common = {
  'Accept': 'application/json, text/plain',
  'X-CSRF-Token': RestService.getCsrfToken(),
  'X-Requested-With' : 'XMLHttpRequest',
};

axios.defaults.headers.post['Content-Type'] = 'application/json';

export async function getQuizStudentAnswers(quiz_id, student_answer_id) {
    try {
      const {data} = await axios.post('/api/quiz/questions', {student_answer_id, quiz_id});
      let payload = [];
      if(data.errcode == 200) {
        payload = data.payload;
        return {questions:  data.questions, quiz: data.quiz, student: data.student };
      } else {
        return []
      }
    } catch (error) {
      return [];
    }
}


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/StudentAnswerQuiz/actions.js